export const LOADING = `dashboardLoading`;
export const ERROR = `dashboardError`;
export const GET = `dashboardGet`;
export const NEWVALUE = `dashboardNewValue`;
export const TRIGGER = `dashboardTrigger`;
